import { createContext } from "react";

export const     loginContext = createContext(false);
